import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { QueryClient } from '@tanstack/react-query';
import _ from 'lodash';

let queryClient: QueryClient | null = null;

export const getOrCreateQueryClient = () => {
    if (!queryClient) {
        queryClient = new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: Infinity,
                    refetchInterval: false,
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                    refetchOnMount: false,
                    retry: false,
                    retryOnMount: false
                }
            }
        });
    }

    return queryClient;
};

export const getQueryClient = () => {
    return queryClient;
};

export const destroyQueryClient = () => {
    queryClient = null;
};

export const SITE_CONTEXT_CACHE_KEY = 'site_context';

export function getCurrentStateKey(): string {
    const queryClient = getOrCreateQueryClient();
    const context = queryClient.getQueryData([SITE_CONTEXT_CACHE_KEY]);
    const contextStateKey = _.get(context, 'data.state_key')!;
    const routerStateKey = getQueryParameter(getCurrentLocation(), 'state_key');

    return contextStateKey || routerStateKey || 'MISSING_STATE_KEY';
}

export function getCacheKeyFromAction({
    actionName,
    queryParams
}: {
    actionName: string;
    queryParams?: string[];
}) {
    const noPrefix = actionName.replace('api/', '');
    const [method, ...identifier] = noPrefix.split('_');
    if (method.toLowerCase() !== 'get') return null;

    const cacheKey = [_.snakeCase(identifier.join('_'))];
    if (cacheKey[0] === SITE_CONTEXT_CACHE_KEY) return cacheKey;
    if (!queryParams) return cacheKey;

    return cacheKey.concat(queryParams);
}

export function storeResponseInReactQuery({
    cacheKey,
    response
}: {
    cacheKey: string[] | null;
    response: unknown;
}) {
    if (cacheKey === null) return;

    const queryClient = getOrCreateQueryClient();
    return queryClient.setQueryData(cacheKey, response);
}
